<organization-select        #orgManager
                            autoSelectFirst = "true"
                            class = "mr-3"></organization-select>

<site-select                #siteManager
                            [org]           =   "orgManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"></site-select>

<device-select              #deviceManager
                            [site]          =   "siteManager?.currentValue"
                            autoSelectFirst =   "true"
                            class           =   "mr-3"></device-select>

<br>

<help-alert
                            action      = "help.page.device_service.action"
                            info        = "help.info"
                            description = "help.page.device_service.description"></help-alert>

<device-service-checkbox
                            [site]   = "siteManager?.currentValue"
                            [device] = "deviceManager?.currentValue"></device-service-checkbox>
